import React, { ReactNode } from 'react';

import styles from './SlideDrawer.module.css';

import { CSSProperties } from 'styled-components';

type ModalContainerProps = {
	isOpen: boolean;
	children: ReactNode;
	styles: CSSProperties;
};

export const AnimatedModalContainer = ({ isOpen, children, styles: customStyles }: ModalContainerProps) => {
	return (
		<div
			className={`${styles.drawerContainer} ${isOpen ? styles.drawerOpen : styles.drawerContainer}`}
			style={customStyles}
		>
			{children}
		</div>
	);
};
